import Layout from "../components/Layout";

function HomePage() {
  return (
    <Layout>
      <main role="main">
        <div>
          <div className="more">
            <div className="heading-marketing">
              <i className="fa fa-play heading-icon"></i>
              <br />
            </div>
            <br />

            <div className="row" style={{ textAlign: "justify" }}>
              <div className="offset-2 col-8">
                <br />
                <h3>
                  Essayez notre saisie intuitive de votre liasse LMNP,
                  un service que nous proposons pour 106,80 EUR TTC
                </h3>

              </div>
            </div>

            <br />
            <br />
            <div className="heading-marketing">
              <i className="fa fa-play heading-icon"></i>
              <br />
              <h2 className="page-title-marketing">
                Déclaration annuelle LMNP en ligne
              </h2>
            </div>
            <br />
            <br />
            <div className="row entrez-siren">
              <div className="offset-3 col-md-6">
                <a
                  href="/nouveau-dossier"
                  className="btn btn-success"
                  type="submit"
                >
                  <span className="fa fa-check"></span>&nbsp;&nbsp;Commencez une déclaration LMNP</a>
              </div>
            </div>
            <br />

            <br />
          </div>
        </div>
      </main>
    </Layout>

  );
}

export default HomePage;
